import React from "react";
import styled from "styled-components";

// Component for Industry Card
function IndustryCard({ icon, title, text }) {
  const renderIcon = (name) => {
    switch (name) {
      case "healthcare":
        return "🩺";
      case "realestate":
        return "🏠";
      case "ecommerce":
        return "🛒";
      case "fintech":
        return "💳";
      case "education":
        return "🎓";
      case "automotive":
        return "🚗";
      case "logistics":
        return "🚚";
      case "tourism":
        return "🧭";
      case "ai":
        return "🤖";
      default:
        return "✨";
    }
  };
  return (
    <Card>
      <Icon>{renderIcon(icon)}</Icon>
      <h3>{title}</h3>
      <p>{text}</p>
    </Card>
  );
}

export default function Industries() {
  const industries = [
    {
      icon: "healthcare",
      title: "Healthcare",
      text: "AI-powered solutions to enhance patient care, optimize workflows, and ensure data security.",
    },
    {
      icon: "realestate",
      title: "Real Estate",
      text: "Intelligent tools for property management, predictive analytics, and client engagement.",
    },
    {
      icon: "ecommerce",
      title: "E-Commerce",
      text: "Advanced AI & IT solutions to improve sales, customer experience, and operational efficiency.",
    },
    {
      icon: "fintech",
      title: "FinTech",
      text: "Secure and scalable technology for payments, risk management, and financial analytics.",
    },
    {
      icon: "education",
      title: "Education",
      text: "Smart learning platforms, personalized content, and analytics for better educational outcomes.",
    },
    {
      icon: "automotive",
      title: "Automotive",
      text: "Connected car solutions, predictive maintenance, and intelligent logistics for the automotive industry.",
    },
    {
      icon: "logistics",
      title: "Logistics",
      text: "Supply chain optimization, route planning, and real-time tracking using AI technology.",
    },
    {
      icon: "tourism",
      title: "Tourism",
      text: "Smart travel planning, dynamic pricing, personalization, and data-driven operations.",
    },

    {
      icon: "ai",
      title: "AI & Automation",
      text: "Agentic AI assistants, workflow automation, and secure, scalable intelligence.",
    },
  ];

  return (
    <Wrapper id="industries">
      <div className="whiteBg">
        <div className="container">
          <HeaderInfo>
            <h1 className="font40 extraBold">Delivering Measurable Impact Across Industries</h1>
            <p className="font13">
              Our AI & IT services & solutions create long-lasting competitive advantages and support diverse use cases across all major industries.
            </p>
          </HeaderInfo>
          <CardsWrapper className="flexSpaceNull">
            {industries.map((item, index) => (
              <CardBox key={index}>
                <IndustryCard
                  icon={item.icon}
                  title={item.title}
                  text={item.text}
                />
              </CardBox>
            ))}
          </CardsWrapper>
        </div>
      </div>
    </Wrapper>
  );
}

// Styled Components
const Wrapper = styled.section`
  width: 100%;
  padding: 50px 0;
`;
const HeaderInfo = styled.div`
  margin-bottom: 50px;
  @media (max-width: 860px) {
    text-align: center;
  }
`;
const CardsWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  @media (max-width: 860px) {
    flex-direction: column;
    align-items: center;
  }
`;
const CardBox = styled.div`
  width: 31%;
  margin-bottom: 30px;
  @media (max-width: 860px) {
    width: 100%;
    max-width: 370px;
  }
`;
const Card = styled.div`
  background: #f9f9f9;
  padding: 30px 20px;
  border-radius: 12px;
  text-align: center;
  h3 {
    margin: 15px 0;
  }
  p {
    font-size: 14px;
    color: #555;
  }
`;
const Icon = styled.div`
  font-size: 40px;
  margin-bottom: 15px;
`;
